import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import {
    DOC_TYPE_DOWNLOADABLE,
    DOC_TYPE_INTERNAL,
    DOC_TYPE_REQUIRED,
    documentTypes,
    findLabelByDocTypeId,
} from '@europrocurement/l2d-domain';
import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

type DocTypeType =
    | typeof DOC_TYPE_REQUIRED
    | typeof DOC_TYPE_INTERNAL
    | typeof DOC_TYPE_DOWNLOADABLE;

type UpdateFileTypeDocModalProps = {
    label: string;
    fichierId: number;
    typeDoc: DocTypeType;
    actionOnValidation: (fichierId: number, typeDoc: DocTypeType) => void;
};

const UpdateFileTypeDocModal: React.FunctionComponent<UpdateFileTypeDocModalProps> = function ({
    label,
    fichierId,
    typeDoc,
    actionOnValidation,
}) {
    const formStructure: FormStructure[] = [
        {
            type: 'select',
            name: 'typeDoc',
            inputlabel: 'Type de document',
            placeholder: 'Type de document',
            options: documentTypes.map((doc) => ({ value: doc.value, label: doc.label })),
            rules: {
                required: 'Vous devez renseigner le type de document',
            },
            defaultValue: { value: typeDoc, label: findLabelByDocTypeId(typeDoc) },
        },
    ];
    const formContext = useForm<FieldValues>({ mode: 'onChange' });
    const selectedTypeDoc = formContext.watch('typeDoc');

    // Met à jour la valeur par défaut
    useEffect(() => {
        if (typeDoc) {
            formContext.setValue('typeDoc', {
                value: typeDoc,
                label: findLabelByDocTypeId(typeDoc),
            });
        }
    }, [typeDoc, formContext]);

    const formProps = {
        formContext,
        onSubmit: () => {},
        submitButton: {
            displayed: false,
        },
    };

    // Catch select onChange
    useEffect(() => {
        if (selectedTypeDoc && selectedTypeDoc.value !== typeDoc) {
            actionOnValidation(fichierId, selectedTypeDoc.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTypeDoc, typeDoc]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Typography variant="l2dh6">Déplacer le fichier ?</Typography>

            <Typography variant="l2dbodyxs">
                Déplacer le fichier {label} vers un autre type de document.
            </Typography>

            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
        </Box>
    );
};

export default UpdateFileTypeDocModal;
